import { render, staticRenderFns } from "./CategorySignCheckbox.vue?vue&type=template&id=72150d0f"
import script from "./CategorySignCheckbox.vue?vue&type=script&lang=js"
export * from "./CategorySignCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CategorySignCheckbox.vue?vue&type=style&index=0&id=72150d0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports